import { deprecated } from '../constants/texts';
import Pagination from 'react-paginate';

export default class ReactPaginateDeprecated extends React.PureComponent {
  componentDidMount() {
    console.warn('React Paginate -- ', deprecated);
  }

  render() {
    return <Pagination {...this.props} />;
  }
}
